var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSettingAvatarSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#0FD683",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.129 10l-.431.417.431.446.431-.446L7.13 10zm3.44-4.417l-3.871 4 .862.834 3.871-4-.862-.834zm-3.009 4l-2.129-2.2-.862.834 2.129 2.2.862-.834z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNyIgZmlsbD0iIzBGRDY4MyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KICA8cGF0aCBkPSJNNy4xMjkwMyAxMEw2LjY5Nzg3IDEwLjQxNzNMNy4xMjkwMyAxMC44NjI4TDcuNTYwMTkgMTAuNDE3M0w3LjEyOTAzIDEwWk0xMC41Njg4IDUuNTgyNzVMNi42OTc4NyA5LjU4Mjc1TDcuNTYwMTkgMTAuNDE3M0wxMS40MzEyIDYuNDE3MjVMMTAuNTY4OCA1LjU4Mjc1Wk03LjU2MDE5IDkuNTgyNzVMNS40MzExNiA3LjM4Mjc1TDQuNTY4ODQgOC4yMTcyNUw2LjY5Nzg3IDEwLjQxNzNMNy41NjAxOSA5LjU4Mjc1WiIgZmlsbD0id2hpdGUiLz4KICA8L3N2Zz4KICA=";
export { SvgAccountSettingAvatarSelected as ReactComponent };